import * as React from 'react';
import {TextField} from '@sail/ui';

export const Controlled = () => {
  const [textValue, setTextValue] = React.useState();
  return (
    <TextField
      value={textValue}
      onChange={(e) => {
        setTextValue(e.target.value);
        // eslint-disable-next-line no-console
        console.log(e);
      }}
      label="First name"
    />
  );
};
